import React from 'react';
import { Box, TableCell, Typography } from '@mui/material';
import { tableHeaderCellSx } from './tableStyles';

type Props = {
  label: string;
  sortKey?: string | null;
  activeSortKey?: string | null;
  sortDir?: 'asc' | 'desc';
  onSort?: (key: string) => void;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  sticky?: boolean;
  stickyOffset?: number;
  stickyBackgroundColor?: string;
};

export const TableHeaderCell: React.FC<Props> = ({
  label,
  sortKey,
  activeSortKey,
  sortDir = 'asc',
  onSort,
  width,
  align,
  sticky = false,
  stickyOffset = 0,
  stickyBackgroundColor = 'white',
}) => {
  const isSortable = Boolean(sortKey && onSort);
  const isActive = isSortable && sortKey === activeSortKey;
  const handleClick = () => {
    if (sortKey && onSort) {
      onSort(sortKey);
    }
  };

  return (
    <TableCell
      onClick={isSortable ? handleClick : undefined}
      sx={[
        tableHeaderCellSx,
        {
          cursor: isSortable ? 'pointer' : 'default',
          textAlign: align,
          ...(width ? { width, maxWidth: width } : {}),
          ...(sticky
            ? {
                position: 'sticky',
                top: stickyOffset,
                zIndex: 101,
                backgroundColor: stickyBackgroundColor,
              }
            : {}),
        },
      ]}
    >
      <Box display="inline-flex" alignItems="center" position="relative">
        <Typography
          variant="inherit"
          color="inherit"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {label}
        </Typography>
        {isActive && (
          <Typography
            variant="caption"
            sx={{
              position: 'absolute',
              left: '100%',
              ml: 0.5,
              transform: 'translateY(-50%)',
              top: '50%',
            }}
          >
            {sortDir === 'asc' ? '↑' : '↓'}
          </Typography>
        )}
      </Box>
    </TableCell>
  );
};
